import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {OrganizationData} from '../model/organization-data';
import {HR_CORE_ORG_ROUTE_CONFIG, HrCardRouteConfig} from '../model/hr-card-route-config';

@Injectable({
    providedIn: 'root',
})
export class SelectedOrganizationService {
    private refreshDataSub = new Subject<boolean>();
    refreshDataObservable = this.refreshDataSub.asObservable();
    organizationData = null;
    private sourceOrganization = new BehaviorSubject<OrganizationData>(this.organizationData);
    dataOrganization$ = this.sourceOrganization.asObservable();

    private _routeConfig: HrCardRouteConfig = HR_CORE_ORG_ROUTE_CONFIG;
    private sourceRouteConfig = new BehaviorSubject<HrCardRouteConfig>(this._routeConfig);
    private treeNodeData=null;
    routeConfig$ = this.sourceRouteConfig.asObservable();

    public saveData(data: OrganizationData) {
        this.organizationData = data;
        this.sourceOrganization.next(data);
    }

    public clearData() {
        this.organizationData = null;
        this.sourceOrganization.next(null);
    }

    public changeRouteConfig(hrCardRouteConfig: HrCardRouteConfig) {
        this._routeConfig = hrCardRouteConfig;
        this.sourceRouteConfig.next(hrCardRouteConfig);
    }

    public getRouteConfig(): HrCardRouteConfig {
        return this._routeConfig;
    }

    public refreshData(e) {
        this.refreshDataSub.next(e)
    }
    public saveTreeNodeData(data){
        this.treeNodeData = data;
    }

    get treeNodeDataList(){
        return this.treeNodeData;
    }
}
